var React = require('react');

function ExpandIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z","fill":"#fff"}));
}

ExpandIcon.defaultProps = {"height":"48","viewBox":"0 0 24 24","width":"32"};

module.exports = ExpandIcon;

ExpandIcon.default = ExpandIcon;
